<template>
    <form
        class="form basic-form user-settings-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <h3 class="field-title">Preferences</h3>
        <div class="form-field">
            <label for="currency">Currency:</label>
            <input
                id="currency"
                v-model="form.currency.value"
                type="text"
                maxlength="5"
            />
            <FormError :errors="errors.currency" />
        </div>

        <div class="form-field">
            <label for="geo">Home city:</label>
            <GeoSearchInput id="geo" v-model="form.geo.value" level="city" />
            <FormError :errors="errors.geo" />
        </div>

        <h3 class="field-title">Tracking</h3>
        <div class="form-field">
            <input
                id="pref-mot"
                v-model="form.preferences.value.track_mot"
                type="checkbox"
            />
            <label for="pref-mot">Means of transport</label>
        </div>

        <div class="form-field">
            <input
                id="pref-trip-expenses"
                v-model="form.preferences.value.track_trip_expenses"
                type="checkbox"
            />
            <label for="pref-trip-expenses">Trip expenses</label>
        </div>

        <div class="form-field">
            <input
                id="pref-location-expenses"
                v-model="form.preferences.value.track_location_expenses"
                type="checkbox"
            />
            <label for="pref-location-expenses">Expenses per location</label>
        </div>

        <h3 class="field-title">Emails</h3>
        <div class="form-field">
            <input
                id="pref-notification-emails"
                v-model="form.preferences.value.notification_emails"
                type="checkbox"
            />
            <label for="pref-notification-emails">
                Email me about shares and friend requests
            </label>
        </div>

        <div v-if="successMessage" class="form-message">
            {{ successMessage }}
        </div>

        <div class="actions">
            <Bttn id="submit-settings" type="submit">Save</Bttn>
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import GeoSearchInput from "js/components/forms/GeoSearchInput";
import FormError from "js/components/forms/FormError";

export default {
    name: "UserSettingsForm",
    components: {
        GeoSearchInput,
        FormError,
    },
    extends: BaseForm,
    props: {
        location: {
            type: Object,
            default: undefined,
        },
    },
    data() {
        return {
            form: {
                currency: {
                    value: null,
                },
                geo: {
                    value: null,
                },
                preferences: {
                    value: {
                        track_mot: false,
                        track_trip_expenses: false,
                        track_location_expenses: false,
                        notification_emails: true,
                    },
                },
            },
        };
    },
};
</script>
